import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import NominationForm from './NominationForm';
import ConfirmationView from './ConfirmationView';

export default function NominationPage() {
  const [submitted, setSubmitted] = useState(false);

  return (
    <Container className="py-4">
      <PageHeader
        col={12}
        title="Recognise a Colleague"
        description="Emplas Window Systems is built on a culture where people feel valued, supported, and connected to a shared purpose. To strengthen this culture and boost performance, engagement, and retention, we have an Employee Recognition Programme aligned to our five core values. 

Through this recognition programme, we actively support the delivery of our mission and vision. Backed by outstanding customer service and IT innovation, Emplas exists to fabricate premium‑quality, high‑security, energy‑efficient windows and doors, helping to secure and insulate homes across the United Kingdom. 

If you believe a college has delivered on one or more of our mission and values, please nominate them below indicating which company value they have demonstrated and why. Those nominated may receive a payment of up to £200!"
        className="mb-4"
      />
      {submitted ? (
        <ConfirmationView onNominateAnother={() => setSubmitted(false)} />
      ) : (
        <NominationForm onSuccess={() => setSubmitted(true)} />
      )}
    </Container>
  );
}
